import axios from 'axios';

const clienteAxios= axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    }
});

export default clienteAxios;